import { gql } from 'graphql-request';

const AnnotationFragment = gql`
  fragment AnnotationFragment on annotation {
    id
    title
    summary
    language
    date
    created_at
    updated_at
    target_chart_dataset_column

    created_from {
      id
      title
      summary
      language
      created_at
      updated_at

      author {
        username
        picture
      }
    }

    event {
      ... on tweet {
        text
        created_at
        full_text
        retweet_count
        favorite_count

        retweeted_status {
          favorite_count
        }

        user {
          name
          verified
          screen_name
          profile_image_url
        }
      }

      ... on website {
        title
        description
        image
      }
    }

    source {
      type
      reference
    }

    style {
      color
      colorful_background
      font_size
      length
      padding {
        horizontal
        vertical
      }
      position
      show_timestamp
      show_arrow
      show_link
      text_color
      text_align
    }

    author {
      username
      picture
    }
  }
`;

export default AnnotationFragment;
